module.exports = __webpack_public_path__ + "media/images/partners/mynita-9eba255f79718b194ea55ff58734e7bb.png";